export default __webpack_public_path__ + "static/media/ec2Open.bd33421d.jpg";